
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { MprcFeedTypography } from 'components/MprcFeedTypography';
import React from 'react';

interface IProps {
    name: string;
    textColor: string;
    backgroundColor: string;
    variant?: "sticker" | "stickerLowercase";
}

export const StickerBox: React.FC<IProps> = (props) => {

    const theme = useTheme();
    const { name, textColor, backgroundColor, variant = 'sticker' } = props;

    return (
        <Box
            sx={{
                marginTop: theme.spacing(0.5),
                display: "inline-flex",
                backgroundColor: backgroundColor,
                color: textColor,
                paddingLeft: theme.spacing(1),
                paddingRight: theme.spacing(1)
            }}
        >
            <MprcFeedTypography variant={variant!} component="span" color="inherit">
                {name}
            </MprcFeedTypography>
        </Box>
    );
};
